import classNames from 'classnames'
import { TAppealVisit } from 'feature/appeals/type'
import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { useState } from 'react'
import { Button, Rating } from 'ui'

import { ModalFeedback } from '../ModalFeedback/ModalFeedback'
import { ModalWrap } from '../ModalWrap/ModalWrap'

import style from './FeedBackBlock.module.scss'
type TFeedBackBlock = {
  grade: TAppealVisit['grade']
  writeFeedbackText: string
  yourFeedbackText: string
  writeFeedbackBtnText: string
  yourFeedbackBtnText: string
  canGrade: boolean
  feedbackModalTitle: string
}

// отзыв
export function FeedBackBlock({
  grade,
  canGrade,
  writeFeedbackText,
  yourFeedbackText,
  writeFeedbackBtnText,
  yourFeedbackBtnText,
  feedbackModalTitle,
}: TFeedBackBlock) {
  const [isFeedbackModalOpen, setFeedbackModalOpen] = useState<boolean>(false)
  useState<boolean>(false)
  const handleCloseFeedbackModal = () => {
    removeModalScrollSafari(false)
    setFeedbackModalOpen(false)
  }

  const handleOpenFeedbackModal = () => {
    setFeedbackModalOpen(true)
    removeModalScrollSafari(true)
  }

  const isTwoButtons = grade?.value < 4

  if (canGrade === false && grade?.value === 0) {
    return <></>
  }

  return (
    <>
      <div
        className={classNames(style.feedback, {
          [style.feedbackTwoBtn]: isTwoButtons,
        })}
      >
        {grade?.value === 0 && writeFeedbackText}
        {grade?.value !== 0 && (
          <div className={style.raiting}>
            <span>{yourFeedbackText}</span>
            <Rating value={grade?.value} readOnly />
          </div>
        )}

        <div className={style.buttonWrapper}>
          {canGrade && grade?.link && (
            <Button
              variant='contained'
              className={style.feedbackButton}
              //@ts-ignore
              to={grade.link}
              target='_blank'
              data-testid='feedback-write-btn'
            >
              {writeFeedbackBtnText}
            </Button>
          )}

          {grade?.value !== 0 && grade?.value < 4 && (
            <div className={style.showYourFeedback}>
              <Button
                variant='contained'
                className={style.feedbackButton}
                onClick={handleOpenFeedbackModal}
                data-testid='feedback-show-btn'
              >
                {yourFeedbackBtnText}
              </Button>
            </div>
          )}
        </div>
      </div>
      <ModalWrap
        isModalOpen={isFeedbackModalOpen}
        onClose={handleCloseFeedbackModal}
      >
        <ModalFeedback
          onClose={handleCloseFeedbackModal}
          grade={grade}
          title={feedbackModalTitle}
        />
      </ModalWrap>
    </>
  )
}
